export default __webpack_public_path__ + "static/media/IndependenceNew3.ba4c4165.JPG";